import { withBemMod } from '@bem-react/core';

import { cnTag } from '../Tag.cn';

import './Tag_view_clear.css';

export type WithViewClearProps = {
    view?: 'clear';
};
export const withViewClear = withBemMod<WithViewClearProps>(cnTag(), {
    view: 'clear',
});
